import useApiMutation from 'shared/hooks/use-api-mutation';
import {BillingRecorencyEnum} from '../types';
import citiesKeys from '../util/cities-keys';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {TranslatedKeys} from 'shared/types/translated-keys';
import {CompanyProps} from 'modules/companies/types';

export interface CreateBillingRecorencyProps {
  companyId: string;
  billingRecorency: BillingRecorencyEnum;
}

export const translatedCreateBillingRecorencyProps: TranslatedKeys<CreateBillingRecorencyProps> =
  {
    companyId: 'Empresa',
    billingRecorency: 'Recorrência do fechamento',
  };

const useCreateBillingRecorency = (cityId: string) => {
  const {create, update, getData} = useQueryHelpers();

  const onSuccess = (data: CompanyProps) => {
    const companies = getData(
      citiesKeys.billingRecorency(cityId),
    ) as CompanyProps[];
    const isCompany = companies.find((company) => company.id === data.id);

    if (isCompany) update(citiesKeys.billingRecorency(cityId), data);
    else create(citiesKeys.billingRecorency(cityId), data);
  };

  return useApiMutation<CreateBillingRecorencyProps>({
    url: '/cities/billing-recorency',
    method: 'PATCH',
    errorTitle: 'Erro ao cadastrar recorrência do fechamento',
    successTitle: 'Recorrência do fechamento',
    successMessage: 'Recorrência do fechamento cadastrado com sucesso',
    redirectUrl: `/settings/cities/${cityId}/billing-recorency`,
    onSuccess,
  });
};

export default useCreateBillingRecorency;
